import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * UTCの日時文字列をJSTに変換してフォーマット
 * @param dateTimeString ISO 8601形式のUTC日時文字列
 * @returns YYYY/MM/DD HH:mm形式のJST日時文字列
 */
export const formatDateTimeToJst = (dateTimeString?: string): string => {
    if (!dateTimeString) return '-';
    return dayjs.utc(dateTimeString).tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm');
};

/**
 * UTCの日時文字列をJSTに変換して日付のみフォーマット
 * @param dateTimeString ISO 8601形式のUTC日時文字列
 * @returns YYYY/MM/DD形式のJST日付文字列
 */
export const formatDateToJst = (dateTimeString?: string): string => {
    if (!dateTimeString) return '-';
    return dayjs.utc(dateTimeString).tz('Asia/Tokyo').format('YYYY/MM/DD');
};

/**
 * UTCの日時文字列をJSTに変換して時刻のみフォーマット
 * @param dateTimeString ISO 8601形式のUTC日時文字列
 * @returns HH:mm形式のJST時刻文字列
 */
export const formatTimeToJst = (dateTimeString?: string): string => {
    if (!dateTimeString) return '-';
    return dayjs.utc(dateTimeString).tz('Asia/Tokyo').format('HH:mm');
};
